import { Row } from '@tanstack/react-table';
import { AssignmentPageColumns } from '@lon/suit/types';
import { PreparedDistrictAssignmentData } from '@lon/shared/types';

type TRowSorting = Row<AssignmentPageColumns> | Row<PreparedDistrictAssignmentData>;  

export function sortQuantileScore(a: TRowSorting, b: TRowSorting) {

  const tmpA = a.original.quantileScore;
  const tmpB = b.original.quantileScore;

  if (!tmpA && tmpB) return -1;
  if (!tmpB && tmpA) return 1;
  if (!tmpB && !tmpA) return 0;

  const first = +(tmpA || '');
  const second = +(tmpB || '');

  return first - second;
}
